/*
 * @Author: your name
 * @Date: 2022-03-04 18:00:57
 * @LastEditTime: 2022-03-04 18:26:37
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \portal\src\api\cloudMonitor\variableList.js
 */
import http from '@/axios/http'
//设置阈值
export function setThreshold(data) {
    return http({
        url: '/api2/threshold/add',
        method: 'post',
        data,
    })
}
//根据终端id查询变量
export function getVariable(data) {
    return http({
        url: '/api2/variable/dtu/list',
        method: 'post',
        data,
    })
}
export function getVariableList(data) {
    return http({
        url: '/api2/variable/list',
        method: 'post',
        data,
    })
}
//查询阈值
export function getThreshold(data) {
    return http({
        url: '/api2/threshold/info',
        method: 'post',
        data,
    })
}
//修改阈值
export function editThreshold(data) {
    return http({
        url: '/api2/threshold/edit',
        method: 'post',
        data,
    })
}
//下发采集
export function monitorThreshold(data) {
    return http({
        url: '/api2/monitor/threshold',
        method: 'post',
        data,
    })
}